import { handleActions } from 'redux-actions'
import { CUSTOMER_TABLE, CUSTOMER_PARTNER_TABLE } from './type'
import { createInitialTableState, createReducerFunction, DESC } from '../../../table/state/reducer'


export const initialState = {
    customerList: [],
    fetching: false,
    error: null,
    ...createInitialTableState(CUSTOMER_TABLE, 'customer_customer', {
        'customer_customer.created': DESC,
    }),
    ...createInitialTableState(CUSTOMER_PARTNER_TABLE, 'customer_customer_partner', {
        'customer_customer.created': DESC,
    }),
}


export default handleActions({
    ...createReducerFunction(CUSTOMER_TABLE),
    ...createReducerFunction(CUSTOMER_PARTNER_TABLE),

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/customer/state/search/reducer.js